<nav class="navbar navbar-expand-lg navbar-light" style="background-color: #e3f2fd;">

  <img src="https://admin.pactel.co.za/xdt/assets/logo.png" width="100" height="100" class="d-inline-block align-top" alt="" style="margin-right: 50px;">

  <button id="MobileViewHeadingButton" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarNavAltMarkup" style="padding-left: 0px;">
    <div class="navbar-nav">


      <!--User-->
      <li class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Boxes')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Boxes
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('ImportBox')">Import Box</a>
          <a class="dropdown-item" (click)="changePage('PrepareBatches')">Prepare Batche's</a>
          <a class="dropdown-item" (click)="changePage('AllocateDistributor')">Allocate Distributor</a>
          <a class="dropdown-item" (click)="changePage('AllocateClients')">Allocate Clients</a>

          <a class="dropdown-item" (click)="changePage('TransferBranch')">Transfer Branch</a>

          <a class="dropdown-item" (click)="changePage('ViewBox')">View</a>
        </div>
      </li>

      <li class="nav-item dropdown">
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Direct')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Direct
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('SelectSuperviser')">Allocate to Superviser</a>
          <a class="dropdown-item" (click)="changePage('SelectAgent')">Allocate to Agent</a>
          <a class="dropdown-item" (click)="changePage('AdminReSelectAgent')" *ngIf="UserLevel=='Admin'">Reallocate to Agent</a>
          <a class="dropdown-item" (click)="changePage('ViewDirectBoxes')">View</a>
        </div>
      </li>

      <li class="nav-item dropdown">
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Agent')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Agents
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('AgentAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('AgentView')">View</a>
        </div>
      </li>

      <li class="nav-item dropdown"><!--User-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Client')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Clients
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('ClientAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('ClientView')">View</a>
        </div>
      </li>


      <!--Manager-->
      <li *ngIf="UserLevel=='Manager' || UserLevel=='Admin'" class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Areas')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Areas
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('AreasAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('AreasView')">View</a>
        </div>
      </li>


      <!-- ---------------------------------------------Admin----------------------------------------------->
      <a *ngIf="UserLevel=='Admin'" [ngClass]="{'nav-item nav-link': true,'active': (ActivePage=='Provinces')}"  (click)="changePage('Provinces')" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup">Provinces</a><!--User-->


      <li *ngIf="UserLevel=='Admin'" class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Distributors')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Distributors
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('DistributorsAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('DistributorsView')">View</a>
        </div>
      </li>

      <li *ngIf="UserLevel=='Admin'" class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Providers')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Providers
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('ProvidersAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('ProvidersView')">View</a>
        </div>
      </li>

      <li *ngIf="UserLevel=='Admin'" class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Branches')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Branches
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('BranchesAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('BranchesView')">View</a>
        </div>
      </li>


      <li *ngIf="UserLevel=='Admin'" class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Users')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Users
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('UsersAdd')">Add</a>
          <a class="dropdown-item" (click)="changePage('UsersView')">View</a>
        </div>
      </li>

      <li *ngIf="UserLevel=='Admin'" class="nav-item dropdown"><!--Admin-->
        <a [ngClass]="{'nav-link dropdown-toggle': true,' active ': (ActivePage=='Admin')}" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Admin
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" (click)="changePage('AdminDeleteBoxes')">Delete boxes</a>
          <a class="dropdown-item" (click)="changePage('AdminViewAuditLog')">View audit log</a>
          <a class="dropdown-item" (click)="changePage('AdminDashboard')">Import dashboard</a>
          <a class="dropdown-item" (click)="changePage('AppReports')">App reports</a>
        </div>
      </li>

      <a [ngClass]="{'nav-item nav-link': true,'active': (ActivePage=='Profile')}"  (click)="changePage('Profile')" style="display: none;">Profile</a>
    </div>
  </div>

  </nav>